const happyCustomer = "/_app/immutable/assets/happy-customer.CCRBfwB2.png";
export {
  happyCustomer as default
};
